var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNothingFoundIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 29C47.4183 29 49.6567 28.2159 51.4743 26.8885L57.2929 32.7071C57.6834 33.0976 58.3166 33.0976 58.7071 32.7071C59.0976 32.3166 59.0976 31.6834 58.7071 31.2929L52.9792 25.565C54.8506 23.5921 56 20.928 56 17.9998C56 11.9335 51.0661 7 45 7C38.9339 7 34 11.9335 34 17.9998C34 24.0665 38.9338 29 45 29ZM45 9C40.0384 9 36 13.0381 36 17.9998C36 22.9619 40.0384 27 45 27C49.9616 27 54 22.9619 54 17.9998C54 13.0381 49.9616 9 45 9Z",
    fill: "#B2B8BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 19C21.4477 19 21 19.4477 21 20C21 20.5523 21.4477 21 22 21L27 21C27.5523 21 28 20.5523 28 20C28 19.4477 27.5523 19 27 19L22 19Z",
    fill: "#B2B8BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 28C21 27.4477 21.4477 27 22 27H27C27.5523 27 28 27.4477 28 28C28 28.5523 27.5523 29 27 29H22C21.4477 29 21 28.5523 21 28Z",
    fill: "#B2B8BF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 35C21.4477 35 21 35.4477 21 36C21 36.5523 21.4477 37 22 37H36C36.5523 37 37 36.5523 37 36C37 35.4477 36.5523 35 36 35H22Z",
    fill: "#B2B8BF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 44C21 43.4477 21.4477 43 22 43H38C38.5523 43 39 43.4477 39 44C39 44.5523 38.5523 45 38 45H22C21.4477 45 21 44.5523 21 44Z",
    fill: "#B2B8BF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.6364C13 14.1708 14.1735 13 15.6 13H27C27.5523 13 28 12.5523 28 12C28 11.4477 27.5523 11 27 11H15.6C13.05 11 11 13.0853 11 15.6364V48.3636C11 50.9147 13.05 53 15.6 53H44.4C46.95 53 49 50.9147 49 48.3636V39.0553C49 38.503 48.5523 38.0553 48 38.0553C47.4477 38.0553 47 38.503 47 39.0553V48.3636C47 49.8292 45.8265 51 44.4 51H15.6C14.1735 51 13 49.8292 13 48.3636V15.6364Z",
    fill: "#B2B8BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNothingFoundIcon);
export default __webpack_public_path__ + "static/media/nothingFoundIcon.32d3be58.svg";
export { ForwardRef as ReactComponent };